import React, { useEffect, useState } from "react";
import { useParams, Navigate } from "react-router-dom";
import axios from "axios";
import { useShop, API } from "../context/ShopContext";
import { useLocale } from "../context/LocaleContext";
import { PageTitle } from "../components/Shared";
import Seo from "../components/Seo";

const LegalPage = () => {
  const { slug } = useParams();
  const { lang } = useShop();
  const { lp, registerAltUrls } = useLocale();
  const [page, setPage] = useState(null);
  const [notFound, setNotFound] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    setNotFound(false);
    axios
      .get(`${API}/pages/${slug}`)
      .then((res) => setPage(res.data))
      .catch(() => setNotFound(true))
      .finally(() => setLoading(false));
    window.scrollTo(0, 0);
  }, [slug]);

  useEffect(() => {
    if (page) registerAltUrls(`/pagine/${page.slug}`, `/en/pages/${page.slug_en || page.slug}`);
  }, [page, registerAltUrls]);

  if (notFound) return <Navigate to={lp("/")} replace />;
  if (loading || !page) {
    return (
      <div className="idm-loading idm-loading-page" data-testid="loading">
        <span className="idm-spinner" />
      </div>
    );
  }

  const content = page.content?.[lang] || page.content?.it || "";

  const isHtml = /<[a-z][\s\S]*>/i.test(content);

  return (
    <div data-testid="legal-page">
      <Seo title={page.title[lang]} description={content.replace(/<[^>]+>/g, "").slice(0, 150)} />
      <PageTitle title={page.title[lang]} />
      <div className="idm-container idm-legal" data-testid="legal-content">
        {isHtml ? (
          <div dangerouslySetInnerHTML={{ __html: content }} />
        ) : (
          content.split("\n").map((line, i) => {
            const trimmed = line.trim();
            if (trimmed === "") return <br key={i} />;
            if (trimmed.startsWith("## ")) return <h3 key={i}>{trimmed.slice(3)}</h3>;
            return <p key={i}>{trimmed}</p>;
          })
        )}
      </div>
    </div>
  );
};

export default LegalPage;
